import styled from 'styled-components';

export const Section = styled.section`
  position: relative;
  background-color: #181726;
  min-height: 750px;

  .step-desc {
    padding-top: 15px;

    h3 {
      color: #ffffff;
      font-size: 85px;
      font-weight: bold;
      letter-spacing: -0.63px;
      line-height: 0.95;
      margin-top: -30px;
      word-break: break-word;
      hyphens: auto;
    }

    p,
    li {
      color: #ffffff;
      font-size: 16px;
      letter-spacing: -0.12px;
      line-height: 30px;
    }

    ul {
      margin-left: 20px;
    }
  }

  .step-count h5 {
    color: ${({ theme: { colors } }) => colors.pink};
    font-size: 135px;
    font-weight: bold;
    letter-spacing: -1.3px;
    line-height: 0.45;
    font-family: inherit;
  }

  .project-steps-main {
    position: relative;
    padding: 103px 0 190px;
    will-change: top, bottom;

    @media only screen and (max-width: 767px) {
      padding-top: 30px;
    }

    &.float {
      width: calc(100% - 30px);
      margin-right: auto;
      margin-left: auto;

      @media (min-width: 576px) {
        max-width: 510px;
      }

      @media (min-width: 768px) {
        max-width: 690px;
      }

      @media (min-width: 992px) {
        max-width: 930px;
      }

      @media (min-width: 1200px) {
        max-width: 1170px;
      }
    }

    &.float {
      position: fixed;
      top: 0;
    }

    &.sticky-bottom {
      padding-top: 0 !important;
    }
  }

  .project-slide-control {
    position: absolute;
    height: 210px;
    left: 0px;
    width: 13px;
    overflow: hidden;

    &--bg,
    &--completed {
      position: absolute;
      top: 0;
      left: 6px;
      height: 0px;
      width: 1px;
    }

    &--completed {
      background-color: ${({ theme: { colors } }) => colors.pink};
      transition: all 0.2s;
    }

    &--bg {
      height: 210px;
      background-color: rgba(255, 255, 255, 0.1);
    }

    .items {
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      height: 100%;
      width: 100%;
      padding-bottom: 12px;
    }
  }

  .single-slide-control {
    position: relative;
    border: 0;

    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      height: 12px;
      width: 12px;
      border: 1px solid #ffffff;
      background-color: #181726;
      border-radius: 50%;
      transition: 0.3s all;
    }

    &.active {
      &::after {
        background-color: ${({ theme: { colors } }) => colors.pink};
        border: 1px solid ${({ theme: { colors } }) => colors.pink};
      }
    }
  }

  .principle-img {
    position: relative;

    .fly-text {
      color: rgba(255, 255, 255, 0.05);
      font-size: 158px;
      font-weight: bold;
      letter-spacing: 12px;
      position: absolute;
      top: -110px;
      left: -200px;
      white-space: nowrap;
      z-index: 0;
      font-family: 'Be Vietnam Pro';
      font-weight: 900;
      pointer-events: none;

      @media only screen and (max-width: 767px) {
        left: 0;
        top: -170px;
      }
    }

    .fly-box {
      background-color: #fafafa;
      position: absolute;
      top: 70px;
      right: -135px;
      z-index: 0;
      opacity: 0.05;
      width: 570px;
      height: 529px;

      @media only screen and (max-width: 767px) {
        top: 200px;
      }

      @media only screen and (max-width: 480px) {
        right: -250px;
        top: 270px;
      }
    }

    .gatsby-image-wrapper {
      @media only screen and (max-width: 767px) {
        max-height: 200px;
      }
    }
  }
  .principle-img img {
    position: relative;
    z-index: 1;
  }

  @media only screen and (max-width: 990px) {
    .step-desc h3 {
      font-size: 45px;
      line-height: 59px;
    }
    .step-count h5 {
      font-size: 135px;
    }
    .principle-img::after {
      display: none;
    }
    .project-slide-control {
      left: -20px;
    }
  }

  @media only screen and (max-width: 767px) {
    min-height: 450px;
    padding-top: 30px;

    .principle-main {
      padding: 80px 0 0;
    }
    .project-slide-control {
      left: 0;
    }
    .single-steps-slider {
      padding-left: 35px;
    }
    .step-count h5 {
      position: absolute;
      font-size: 2.3em;
      margin-top: 10px;
    }

    .step-desc h3 {
      margin: -18px 0 0 55px;
      font-size: 2em;
      line-height: 1.5;
    }
    .step-desc {
      margin-left: 0;

      li,
      p {
        font-size: 14px;
      }
    }
  }

  @media only screen and (max-width: 480px) {
    min-height: 530px;
    overflow: hidden;

    .project-steps-main {
      padding: ${({ aboutPage }) => (aboutPage ? '150px 0 0' : '103px 0 0')};
    }

    .step-count h5 {
      position: static;
    }

    .step-desc h3 {
      margin-left: 0;
    }
  }
`;
